/*
* Created on Jan 22, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';
import {ActivityCategory, ActivityEvent, LOG_EVENT_MAPPING} from './ActivityConstant'
import {useTimezone} from "../../service/timezone";
import {useTranslation} from "react-i18next";
import {dataCellLabelToDataGridArea} from "../../service/utils";


const ActivityLogTableRowComponent = ({ row_data, index,  doRefresh, disPatcher, translate:t, isOwner, table_head_fields}) => {
    // const {t} = useTranslation();
    const getLogEventMsg = (event_num) => {
        let message = '';
        if (LOG_EVENT_MAPPING.add.includes(event_num)){
            message = t('@Add@');
        }
        else if (LOG_EVENT_MAPPING.remove.includes(event_num)) {
            message = t('@Remove@');
        }
        else if (LOG_EVENT_MAPPING.transfer.includes(event_num)) {
            message = t('@Transfer@');
        }
        else {
            message = t('@Edit@');
        }
        return message
    }

    return (
        <div className="flexbox-trow" key={index}>
            <div className="tbody-cell !w-13" data-cell-label={t(table_head_fields[0].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[0].field_name)}>{t(ActivityCategory[row_data.category-1])}</div>
            <div className="tbody-cell !w-12" data-cell-label={t(table_head_fields[1].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[1].field_name)}>{getLogEventMsg(row_data.event)}</div>
            <div className="tbody-cell !w-27" data-cell-label={t(table_head_fields[2].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[2].field_name)}>{row_data.content}</div>
            <div className="tbody-cell !w-20" data-cell-label={t(table_head_fields[3].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[3].field_name)}>{row_data.user.qid}</div>
            <div className="tbody-cell !w-12" data-cell-label={t(table_head_fields[4].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[4].field_name)}>{row_data.location.country}</div>
            <div className="tbody-cell !w-16 text-align-right" data-cell-label={t(table_head_fields[5].field_name)} data-grid-area={dataCellLabelToDataGridArea(table_head_fields[5].field_name)}>{useTimezone(row_data.created_at)}</div>
        </div>
    );
};

export default ActivityLogTableRowComponent;